import React from 'react'
import { debounce } from '@mobi/utils/functions/debounce'
import { Button } from '@mobi/component-library/Base/Buttons/Button'
import { LoadingSpinner } from '@mobi/component-library/Feedback/LoadingSpinner'

export const AutoFetchButton: React.FC<{
  onClick: () => void
  isFetching: boolean
}> = ({ onClick, isFetching }) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const containerEl = wrapperRef.current
    if (!containerEl || isFetching) return
    const fetchNextPage = debounce(onClick, 300)
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) fetchNextPage()
    })
    observer.observe(containerEl)
    return () => observer.disconnect()
  }, [wrapperRef, onClick, isFetching])

  return (
    <div ref={wrapperRef}>
      <Button color='secondary_outline' size='sm' onClick={onClick} isFullWidth>
        {isFetching ? <LoadingSpinner size='2rem' /> : 'Load More'}
      </Button>
    </div>
  )
}
